import { NgOptimizedImage } from '@angular/common';
import {   ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-brands-we-do',
  standalone: true,
  imports: [NgOptimizedImage],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './brands-we-do.component.html',
  styleUrl: './brands-we-do.component.scss'
})
export class BrandsWeDoComponent {

}
